// import
import React from 'react';
import Dashboard from "views/Dashboard/Dashboard.js";
import MasterTenantManagement from "views/Dashboard/MasterTenantManagement.js";
import MasterPackage from 'views/Dashboard/MasterPackage';
import TenantWizard from 'views/Dashboard/TenantCreateStep';
import TenantDetail from 'views/Dashboard/TenantDetail';
import EditTenant from 'views/Dashboard/EditTenant';
import TenantMenuSetting from 'views/Dashboard/TenantMenuSetting';
import UserManagement from "views/Dashboard/UserManagement.js";
import MyProfile from "views/Dashboard/MyProfile.js";
import ActivityLogPage from "views/Dashboard/ActivityLogPage.js";
import SettingsPage from "views/Dashboard/SettingsPage.js";
import HelpSupport from "views/Dashboard/HelpSupport.js";
import SignIn from "views/Pages/SignIn.js";
import { HomeIcon, PersonIcon, SettingsIcon, DocumentIcon, ActivityLogIcon } from "components/Icons/Icons";

/**
 * Admin layout routes
 * Each route: { path, name, icon, component, layout }
 * Add additional routes here as needed.
 */
/** @type {Array<Object>} */
const dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: <HomeIcon color="inherit" />,
    component: Dashboard,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/create-tenant",
    name: "Create Tenant",
    icon: <SettingsIcon color="inherit" />,
    component: TenantWizard,
    layout: "/admin",
    sidebar: false
  },
  {
    path: "/user-management",
    name: "User Management",
    icon: <PersonIcon color="inherit" />,
    component: UserManagement,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/master-tenant",
    name: "Master Tenant",
    icon: <SettingsIcon color="inherit" />,
    component: MasterTenantManagement,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/master-package",
    name: "Master Package",
    icon: <DocumentIcon color="inherit" />,
    component: MasterPackage,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/activity-log",
    name: "Activity Log",
    icon: <ActivityLogIcon color="inherit" />,
    component: ActivityLogPage,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/settings",
    name: "Settings",
    icon: <SettingsIcon color="inherit" />,
    component: SettingsPage,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/help-support",
    name: "Help & Support",
    icon: <ActivityLogIcon color="inherit" />,
    component: HelpSupport,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/tenant-detail/:id",
    name: "Tenant Detail",
    icon: <SettingsIcon color="inherit" />,
    component: TenantDetail,
    layout: "/admin",
    sidebar: false
  },
  {
    path: "/edit-tenant/:id",
    name: "Edit Tenant",
    icon: <SettingsIcon color="inherit" />,
    component: EditTenant,
    layout: "/admin",
    sidebar: false
  },
  {
    path: "/tenant-menu-setting/:id",
    name: "Setting Menu Tenant",
    icon: <SettingsIcon color="inherit" />,
    component: TenantMenuSetting,
    layout: "/admin",
    sidebar: false
  },
  {
    path: "/my-profile",
    name: "My Profile",
    icon: <PersonIcon color="inherit" />,
    component: MyProfile,
    layout: "/admin",
    sidebar: false
  },
  {
    path: "/signin",
    name: "Sign In",
    icon: <DocumentIcon color='inherit' />,
    component: SignIn,
    layout: "/auth",
    sidebar: false
  },
];

export default dashRoutes;